import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { ContactUs } from '@/components/contact-us/contact-us';
import { BasePageLayout } from '@/components/layouts/base-page-layout/base-page-layout';
import { Typography } from '@/components/typography/typography';

import { Stack } from '@/lib/shadcn/components/ui/stack/stack';

interface ErrorPageLayoutProps extends PropsWithChildren {
  headerComponent?: React.ReactNode;
  withContactUs?: boolean;
}

export function ErrorPageLayout({
  headerComponent = null,
  withContactUs = false,
  children,
}: ErrorPageLayoutProps) {
  const { t } = useTranslation();

  return (
    <BasePageLayout className="gap-unit-10 overflow-y-auto bg-slate-100 px-unit-8 pb-unit-8 pt-unit-10">
      {headerComponent}
      {children}
      {withContactUs ? (
        <Stack gap={6}>
          <Typography.p4 className="text-slate-400">
            {t('errors.contact-us')}
          </Typography.p4>
          <ContactUs />
        </Stack>
      ) : null}
    </BasePageLayout>
  );
}
